import request from 'utils/request';
import { isSuccess } from 'utils/utils';

export async function getOrderShopeeDetail (token) {
  const response = await request.getNowShip(
    '/api/common/sharing/get_detail',
    {
      token,
    },
  );
  if (isSuccess(response)) {
    return response.reply;
  }
  // Error
  window.location.href = '/';
  throw response.result;
}
